<template>
  <PflegeCollapseWrapper
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    :heading="props.blok.heading"
    :tag="props.blok.headingTag"
    :collapse-group="props.blok.CollapseGroup ?? []"
  >
    <template #default="{ item }">
      <PflegeCollapseItem
        :heading="item.headline"
        :heading-tag="item.headlineTag"
        :heading-class="item.headlineClass"
      >
        <template #expansion>
          <WPBlockExpansionPanel v-for="panel in item.content" :key="panel._uid" :blok="panel" />
        </template>
      </PflegeCollapseItem>
    </template>
  </PflegeCollapseWrapper>
</template>

<script lang="ts" setup>
import { PflegeCollapseItem, PflegeCollapseWrapper } from '@webcarelbj/shared-components'
import { BlokBase, BlokBaseComponentTemplate, BlokProps } from '../../types/blok'
import { ExpansionPanel as WPBlockExpansionPanel } from '../'
import { type ExpansionPanelBlok } from '../'

export interface CollapseItemBlok extends BlokBase {
  headline?: string
  headlineTag?: '' | 'h1' | 'h2' | 'h3'
  headlineClass?: '' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  content?: ExpansionPanelBlok[]
}

export interface CollapseComponentBlok extends BlokBaseComponentTemplate {
  CollapseGroup?: CollapseItemBlok[]
  tag?: '' | 'div' | 'article' | 'fieldset'

}

const props = defineProps<BlokProps<CollapseComponentBlok>>()
</script>
